<template>
  <v-text-field
    :type="field.data.attrs.textType"
    :rules="getFieldRules()"
    v-model="value"
  ></v-text-field>
</template>

<script>
export default {
  name: 'TextField',
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {
    value(val) {
      this.onChange({
        id: this.field._id,
        value: { text: val },
        rawValues: val,
        ...this.getValidationResults()
      })
    }
  },
  created() {
    if (this.defaultValue) {
      this.value = this.defaultValue
    }
  },
  methods: {
    getErrMsg() {
      const rules = this.getFieldRules()
      for (const f of rules) {
        const ruleRes = f(this.value)
        if (typeof ruleRes === 'string') {
          return ruleRes
        }
      }
      return null
    },
    getValidationResults() {
      const errMsg = this.getErrMsg()
      return errMsg ? { errMsg, valid: false } : { errMsg, valid: true }
    },
    getFieldRules() {
      const rulesF = []
      if (this.field.data.required) {
        rulesF.push(value => !!value || 'Required')
      }
      if (this.field.data.attrs.hasMin) {
        rulesF.push(
          value =>
            (value && value.length >= this.field.attrs.min) ||
            `Min length is ${this.field.attrs.min}`
        )
      }
      if (this.field.data.attrs.hasMax) {
        rulesF.push(
          value =>
            (value && value.length <= this.field.attrs.max) ||
            `Max length is ${this.field.attrs.max}`
        )
      }
      if (this.field.data.attrs.textType == 'Email') {
        rulesF.push(value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        })
      }
      if (this.field.data.attrs.textType == 'Phone') {
        rulesF.push(value => {
          const pattern = /(\d){1,5}/
          return pattern.test(value) || 'Invalid phone.'
        })
      }
      return rulesF
    }
  }
}
</script>

<style lang="scss" scoped></style>
